export default __webpack_public_path__ + "static/media/stick-btn.0a8c8209.svg";